export interface User {
  name: string;
  demo: boolean;
  logo: string;
  available_customers: AvailableCustomer[];
  user_id: number;
  selected_customer: Customer;
  cognito?: boolean;
  id?: string;
  id_token?: string;
  desktopPages?: Page[] | null;
  email?: string;
  edited_ar_ces?: {  [key: string]: string; };
}

export interface AuthUser extends User {
  cognito?: boolean;
  id_token?: string;
  desktopPages?: any;
  permissions?: string[];
}

export interface Customer {
  demo: boolean;
  name: string;
  report_pages: Page[];
  permissions: string[];
  locale: string;
  force_mfa_on_every_login: boolean;
  locales?: number[];
  cp_id: string;
  cab_activated: boolean;
  adapter: string;
  esp_type: string;
  bu_type?: BUType | null;
  purchased_services: {
    cab: PurchasedService;
    auditready: PurchasedService;
    blast: PurchasedService;
    phishcage?: PurchasedService;
    smishing?: PurchasedService;
    home_page?: HomePage;
  };
  logo: string;
  secondary_banner_color: string;
  can_edit_attack: boolean;
  onboarding_completed: boolean;
  exclude_by_min_buckets: boolean;
  demo_included_modules?: number[];
  demo_included_buckets?: string[];
  min_required_buckets?: number;
  edited_ar_ces?: { [key: string]: string; };
  edited_cab_elements?: { [key: string]: any; };
  edited_bucket_ces?: {  [key: string]: string; };
  has_other_bu_cp?: boolean;
  has_targets?: boolean;
  targets_count: number;
  phishcage_uses_hq: boolean;
  has_real_ar_data: boolean;
  zero_cp_tsr: boolean;
  cab_uses_hq: boolean;
  packages: {
    essentials: boolean;
    professional: boolean;
    enterprise: boolean;
    blast_cab: boolean;
    blast: boolean;
    cab_ar: boolean;
    demo: boolean;
    use_hq: boolean;
    smb: boolean;
  };
  addon: {
    auditready: boolean;
  }
  hubspot_profile?: {
    id: number;
    number_of_users_purchased: number | null;
    subscription_start_date: string | null;
    subscription_end_date: string | null;
  }
  plan_details?: {
    scorecard?: {
      any_cp_has_edit_permission: boolean;
    };
  };
}

export interface PurchasedService {
  purchased: boolean;
  activation_status: string;
}

export enum HomePage {
  Dashboard = 1,
  Courses = 2,
  Smishing = 3,
}

export enum BUType {
  Managed = 1,
  SemiManaged = 2,
  Autonomous = 3,
}

export interface UserInfoResponse {
  name: string;
  email: string;
  id: number;
  selected_customer: Customer;
  available_customers: { "id": number; "display_name": string; "hq_id": number | null }[];
  id_token?: string | null;
  cognito?: boolean;
}

export interface AvailableCustomer {
  id: number;
  display_name: string;
  hq_id: number | null;
}

export interface SwitchCustomerResponse {
  name: string;
  email: string;
  id: number;
  selected_customer: Customer;
}

export interface Credentials {
  email: string;
  password: string;
}

export interface Page {
  displayName: string;
  nest_under: string;
  name?: string;
  route?: string;
  childRoute?: string;
  permission?: boolean;
}

export interface DevicePages {
  desktopPages?: Page[] | null;
}

export interface PageConfig {
  analytics: Page[];
  resilience?: Page[];
  management: Page[];
  training: Page[];
}

export interface PowerBIResponse {
  cp: string;
  cps: Array<string | number>[];
  id: string;
  type: string;
  power_bi_token: {
    token: string;
    expiration: string;
  },
  reports: PowerBIReports;
}

export interface PowerBIReports {
  real_sent_attacks_exist: boolean;
  customer_has_uploaded_targets: boolean;
  first_campaign_activated: boolean;
  first_campaign_running: boolean;
  first_campaign_passed_six_hours: boolean;
  details: {
    date: string;
    employees: number;
    languages: number;
  }
}

export interface TfaErrorDetail {
  force_mfa_on_every_login?: boolean;
  remember_me?: boolean;
  setup_totp?: string;
  totp_mfa?: boolean;
}
